

// Define an interface for individual breadcrumb menu items
export interface IBreadcumMenuItem {
    title: string;
    count?: string;
    color?: COLOR_BREADCUMENU;
    fontWeight?: FONT_WEIGHT_BREADCUMENU;
    url?: string; // Optional field for non-parent items
}

export enum FONT_WEIGHT_BREADCUMENU {
    F400 = '400',
    F700 = '700',
    Normal = 'normal',
    Bold = 'bold'

}

export enum COLOR_BREADCUMENU {
    Gray600 = 'rgb(75 85 99 / 70%)',
    Gray900 = '#111827',
    Primary = '#ED5A26',
    Yellow = 'yellow',
    Purple = 'purple',
    Pink = 'pink',
    Gray = 'gray',
    Orange = 'orange',
    Cyan = 'cyan',
    Teal = 'teal',
    Default = '#687588'
}

export const URL_BREADCUM = {
    MY_TASK: '#/manage/my-task',
    MY_APPROVALS: '#/manage/my-approvals',
    MY_WATCHLIST: '#/manage/my-watch',
    MY_REQUEST: '#/manage/my-request',
    MY_DRAFT: '#/manage/my-draft',
    ALL_REQUEST: '#/manage/all-request',
    REQUEST_TASK: '#/manage/request-task',
    REQUEST_TRACKING: '#/manage/request-tracking',
    MY_TASK_APPROVE: (workflowId, requisitionId) => `#/manage/my-task/approve/${workflowId}/${requisitionId}`,
    ALL_REQUEST_DETAIL: (workflowId, requisitionId) => `#/manage/all-request/detail/${workflowId}/${requisitionId}`,
    REQUEST_TASK_APPROVE: (workflowId, requisitionId) => `#/manage/request-task/approve/${workflowId}/${requisitionId}`,
    REQUEST_TRACKING_DETAIL: (workflowId, requisitionId) => `#/manage/request-tracking/detail/${workflowId}/${requisitionId}`,
    POSTING_LIST: '#/manage/job-posting',
    ONLINE_CANDIDATE: '#/manage/talent-pool-applicants',
    RECRUITMENT_CANDIDATE: '#/manage/recruitment-candidate',
    RECRUITMENT_CANDIDATE_GROUP: '#/manage/duplicate-candidates',
    RECOMMENDER_CV: '#/manage/erp-candidates',
    SAVED_CANDIDATE: '#/manage/my-talent-pool',
    SAVED_CANDIDATE_DETAIL: (aggId) => `#/manage/my-talent-pool/detail/${aggId}`,
    EX_EMPLOYEE: '#/manage/former-employee',
    STUDENT_PROGRAM: '#/manage/student-program-applicants',
    KEY_STUDENT: '#/manage/key-student',
    PROGRAM_EVENTS: '#/manage/events',
    CANDIDATE_CHECK_IN: '#/manage/attendees',
    PROGRAM_FIELDS: '#/manage/fields',
    PROGRAM_QUESTIONS: '#/manage/program-questionnaires',
    PROGRAM_GIFTS: '#/manage/rewards',
    SURVEY_QUESTIONS: '#/manage/create-questionnaire',
    QUESTIONNAIRE_SURVEY: '#/manage/questionnaire-list',
    SURVEY_RESULT: '#/manage/survey-results',
    ERP_CONFIG: '#/manage/erp-config',
    ERP_PAYMENT_CONFIG: '#/manage/erp-payment-config',
    ERP_EXCLUSION: '#/manage/erp-exclusion',
    ERP_PAYMENT: '#/manage/eligible-erp-list',
    ERP_PAYMENT_TIME: '#/manage/erp-payment',
    USER_REGISTER: '#/manage/registered-user'
}